import { render, staticRenderFns } from "./light-footer.vue?vue&type=template&id=6024899c"
import script from "./light-footer.vue?vue&type=script&lang=js"
export * from "./light-footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports